var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("booking-alerts", { attrs: { booking: _vm.booking } }),
      _vm._v(" "),
      !_vm.booking.is_offer && _vm.booking.threads.length && !_vm.$userIsIntern
        ? _c("booking-thread-list", {
            attrs: { threads: _vm.booking.threads, booking: _vm.booking },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.booking.is_offer && (_vm.$userIsNotTalent || _vm.showAllTalents)
        ? _c("booking-talent-list", {
            attrs: {
              showAllTalents: !_vm.$userIsNotTalent && _vm.showAllTalents,
              booking: _vm.booking,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("booking-details", {
        attrs: {
          booking: _vm.booking,
          "property-mutator": _vm.setBookingProperty,
        },
      }),
      _vm._v(" "),
      _vm.canViewRegionalAdminOptions || !_vm.$userIsAdmin
        ? _c(
            "div",
            { staticClass: "dashboard-block button-bank" },
            [
              _vm.$userIsAdmin
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn btn-info",
                      attrs: {
                        to: {
                          name: "bookings.edit",
                          params: { id: _vm.booking.id },
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-pencil" }),
                      _vm._v(" Edit Booking\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin || _vm.$userIsClient
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn btn-info",
                      attrs: {
                        to: {
                          name: "bookings.duplicate",
                          params: { id: _vm.booking.id },
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-clone" }),
                      _vm._v(" Duplicate Booking\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userCanReactivateBooking
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { click: _vm.handleReactivateBookingCallback },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-check" }),
                      _vm._v(" Reactivate Booking\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userCanMarkAsBookedUnpaid
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { click: _vm.handleMarkBookingBookedUnpaid },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-close" }),
                      _vm._v(" Mark as Booked but Unpaid\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userCanMarkCompletedAsIncomplete
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-info",
                      attrs: {
                        click: _vm.handleMarkBookingCompletedIncomplete,
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _vm._v(" Mark Incomplete\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !this.booking.is_offer
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                        "data-toggle": "modal",
                        "data-target": "#replace-talent",
                        disabled: _vm.bookingIsCompleted,
                      },
                      on: { click: _vm.toggleGetTalent },
                    },
                    [
                      _vm.userCanReplaceTalent
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              attrs: { disabled: _vm.bookingIsCompleted },
                            },
                            [
                              _c("i", { staticClass: "fa fa-fw fa-refresh" }),
                              _vm._v(
                                " Replace " +
                                  _vm._s(
                                    _vm._f("sentenceCase")(_vm.$starLabel)
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userCanCancelBooking
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { click: _vm.handleCancelBookingCallback },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-close" }),
                      _vm._v(" Cancel Booking\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userCanRefundBooking
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { click: _vm.handleRefundBookingCallback },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-close" }),
                      _vm._v(" Refund Booking\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.cancellationRequested
                ? _c(
                    "button",
                    { staticClass: "btn btn-default", attrs: { disabled: "" } },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-close" }),
                      _vm._v(" Cancellation requested\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin && _vm.bookingIsOnHold
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { click: _vm.handleRestoreBookingCallback },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-undo" }),
                      _vm._v(" Restore Booking\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$chatsModuleEnabled &&
              _vm.userCanCreateBookingThreads &&
              !_vm.booking.is_offer
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { click: _vm.handleCreateBookingThreads },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-commenting" }),
                      _vm._v(" Create Chats\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.booking.package_id && this.$userIsAdmin
                ? _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { click: _vm.handleMarkBookingCompleteCallback },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-check" }),
                      _vm._v(" Complete Booking\n    "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin ||
      _vm.$userIsClient ||
      ((_vm.$userIsTalent || _vm.$userIsManager) &&
        _vm.$showClientDetailsBookingModuleEnabled)
        ? _c("booking-client-details", { attrs: { booking: _vm.booking } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin
        ? _c("booking-notes", { attrs: { booking: _vm.booking } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin && !_vm.$vlastMode
        ? _c("booking-sales-pipeline", {
            key: "1",
            attrs: { booking: _vm.booking },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canViewRegionalAdminOptions
        ? _c("booking-admin-options", { attrs: { booking: _vm.booking } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin && !_vm.$vlastMode && _vm.canViewRegionalAdminOptions
        ? _c("booking-source", { attrs: { booking: _vm.booking } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin
        ? _c("booking-download-pdf", { attrs: { booking: _vm.booking } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.$userIsIntern && !_vm.booking.package_id
        ? _c("booking-upload-files", { attrs: { booking: _vm.booking } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShoutout &&
      (_vm.bookingIsBooked || _vm.bookingIsCompleted) &&
      (_vm.$userIsAdmin || _vm.$userIsManager)
        ? _c("booking-upload-video", {
            attrs: { booking: _vm.booking, talent: _vm.booking.talent[0] },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.$vlastMode
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("div", { staticClass: "alert alert-icon alert-info" }, [
              _c("i", { staticClass: "fa fa-list" }),
              _vm._v("\n      Read our "),
              _c(
                "a",
                { attrs: { href: _vm.bookingTncLink(), target: "_blank" } },
                [_vm._v("terms and conditions")]
              ),
              _vm._v(" here\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin
        ? _c("booking-replace-talent-modal", {
            attrs: { "get-talent": this.getTalent },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("booking-cancel-reason-modal", {
        ref: "modal",
        on: { input: _vm.handleCancelBookingReason },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }